/** Contratos do Behavior Buffer (Etapa 20) — agregação interna, não Transport. */

import type { BehaviorSignal, BehaviorSignalType } from './signals';

export type BufferDropStrategy =
  | 'drop_oldest'
  | 'drop_newest'
  | 'compress_similar';

export type BufferFlushReason =
  | 'size'
  | 'age'
  | 'hidden'
  | 'destroy'
  | 'manual';

/** Config normalizada do buffer. */
export type NormalizedBufferConfig = {
  readonly enabled: boolean;
  readonly maxSize: number;
  readonly maxAgeMs: number;
  readonly flushSize: number;
  readonly dropStrategy: BufferDropStrategy;
  readonly flushOnHidden: boolean;
};

/** Entry interna do buffer. `count` > 1 quando sinais similares foram compactados. */
export type BufferEntry = {
  readonly signal: BehaviorSignal;
  readonly bufferedAt: number;
  readonly count: number;
};

/**
 * Sinais que representam transições críticas de estado/causalidade e NUNCA
 * podem ser compactados nem descartados preferencialmente.
 */
export const NON_COMPRESSIBLE_SIGNAL_TYPES: readonly BehaviorSignalType[] = [
  'IDLE',
  'ACTIVITY',
  'VISIBLE',
  'HIDDEN',
  'EXIT_INTENT',
];

/** Snapshot read-only para diagnostics. */
export type BufferSnapshot = {
  readonly enabled: boolean;
  readonly size: number;
  readonly maxSize: number;
  readonly flushSize: number;
  readonly maxAgeMs: number;
  readonly dropStrategy: BufferDropStrategy;
  readonly flushCount: number;
  readonly dropCount: number;
  readonly compressedCount: number;
  readonly lastFlushAt: number | undefined;
  readonly lastFlushReason: BufferFlushReason | undefined;
};
